import TransactionTabContainer from 'Pages/Policy/components/TransactionTab/TransactionTabContainer';

export default TransactionTabContainer;
